import React, { useState } from "react";
import { DocumentIcon, MusicCircleicon, FavoritesIcon } from "../components";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
const CatechesisCard = ({
  id,
  slug,
  title,
  openTeg,
  catechesis,
  aboutHours,
  favorite,
  catList,
  imageUrl,
  onToggleFavorite,
  count,
  description,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <div className="relative">
      {/* {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 backdrop-blur-sm rounded-xl z-10">
                <Loader2 className="animate-spin h-10 w-10 text-gold-600" />
                </div>
            )} */}
      <Link to={`/learn-the-faith/${slug}`}>
        <div className={`flex flex-col transition duration-300`}>
          <div className="relative rounded-t-xl">
            <img
              src={imageUrl}
              className="h-full max-h-[136px] w-full rounded-t-xl object-cover"
              alt="image-2"
            />
          </div>
          <div className="p-4 rounded-b-xl bg-gold-50">
            <h5 className="mb-2 text-base font-semibold leading-5 text-left text-gray-900">
              {title}
            </h5>
            <p className="mb-6 text-lg font-normal leading-7 text-gray-800">
              {description}
            </p>
            <div className="flex flex-row gap-3 mb-3">
              <div className="flex items-center gap-1">
                {catechesis && (
                  <>
                    <DocumentIcon className="text-gray-600" />
                    <p className="text-xs font-normal leading-4 text-gray-600">
                      {count} catechesis
                    </p>
                  </>
                )}
              </div>
              <div className="flex items-center gap-1">
                {aboutHours && (
                  <>
                    <MusicCircleicon className="text-gray-600" />
                    <p className="text-xs font-normal leading-4 text-gray-600">
                      {aboutHours}
                    </p>
                  </>
                )}
              </div>
            </div>
            <div className="flex flex-row justify-between">
              <div className="flex flex-row gap-2">
                {catList &&
                  catList.map((category, index) => (
                    <p
                      key={index}
                      className="px-2 py-1 text-xs font-medium leading-4 bg-white-50 text-gold-500 rounded-27"
                    >
                      {category}
                    </p>
                  ))}
              </div>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault(); // :white_check_mark: Prevent default behavior to stop reload
                  e.stopPropagation(); // :white_check_mark: Prevent event bubbling
                  onToggleFavorite(id, e);
                }}
                className="focus:outline-none"
              >
                <FavoritesIcon
                  filled={Boolean(favorite)}
                  className={`h-6 w-6 transition-colors duration-200 ${
                    favorite
                      ? "text-red-100"
                      : "text-gray-500 hover:text-red-100"
                  }`}
                />
              </button>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};
export default CatechesisCard;
